import { ReactElement } from 'react';
import { tokens } from '../../../../core/theme';
import { useIsDesktop } from '../../../../core/hooks';
import { Channel, CHANNEL_CONFIG } from '../../types/channel';

const MOBILE_ICON_SIZE = 24;
const DESKTOP_ICON_SIZE = 32;
// Fixo nos dois breakpoints no Figma.
const ICON_GAP = 8;
const MOBILE_PADDING = '12px 16px';
const DESKTOP_PADDING = '16px 24px';

type SelectionSummaryCardProps = {
  channel: Channel;
  themeLabel: string | undefined;
};

export const SelectionSummaryCard = ({
  channel,
  themeLabel,
}: SelectionSummaryCardProps): ReactElement => {
  const isDesktop = useIsDesktop();
  const { icon: Icon, title } = CHANNEL_CONFIG[channel];
  const iconSize = isDesktop ? DESKTOP_ICON_SIZE : MOBILE_ICON_SIZE;

  return (
    <div style={{ ...styles.card, padding: isDesktop ? DESKTOP_PADDING : MOBILE_PADDING }}>
      <div style={styles.channelRow}>
        <Icon width={iconSize} height={iconSize} aria-hidden="true" focusable="false" />
        <p style={styles.channelLabel}>{title}</p>
      </div>
      {themeLabel && <p style={styles.themeLabel}>{themeLabel}</p>}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacing.small,
    width: '100%',
    boxSizing: 'border-box',
    border: `1px solid ${tokens.colors.brand.gray.light850}`,
    borderRadius: tokens.radius.small,
    backgroundColor: tokens.colors.global.white,
  },
  channelRow: {
    display: 'flex',
    alignItems: 'center',
    gap: ICON_GAP,
  },
  channelLabel: {
    margin: tokens.spacing.none,
    fontSize: tokens.typography.fontSize.input,
    fontWeight: tokens.typography.fontWeight.medium,
    color: tokens.colors.global.black,
  },
  themeLabel: {
    margin: tokens.spacing.none,
    fontSize: tokens.typography.fontSize.caption,
    fontWeight: tokens.typography.fontWeight.medium,
    color: tokens.colors.brand.gray.DEFAULT,
  },
};
